import { nativeApi } from '@/../../common/src/utils/nativeApi';
import VhkStore, { persistor } from '@/vhkstore';
import { clearH5ApplicationForm, setH5ApplicationForm } from '@/vhkstore/slices/app';
import { createH5ApplicationFormSession } from './h5ApplicationFormSession';

export const h5ApplicationFormSession = createH5ApplicationFormSession({
  read: () => VhkStore.getState().h5AppReducer.h5ApplicationForm,
  write: (applicationForm) => {
    VhkStore.dispatch(setH5ApplicationForm(applicationForm));
  },
  clear: () => {
    VhkStore.dispatch(clearH5ApplicationForm());
    nativeApi.setRequestHeader?.({ applicationForm: '' });
  },
  flush: () => persistor.flush(),
});
